import { keyframes } from '@emotion/react';
import { makeStyles } from 'tss-react/mui';

const rotate = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

export const useOfflineMenuItemStyles = makeStyles()(() => ({
  rotating: {
    animation: `${rotate} 1.5s linear infinite`,
  },
}));
